import {
  backend_url,
  uninterceptedAxiosInstance,
} from "../common/commonVariables";

export const updateJobTitle = async (id, title) => {
  try {
    let params = {
      title,
    };

    const response = await uninterceptedAxiosInstance.put(
      backend_url + `jobs/${id}`,
      { data: params },
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );
    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err?.response?.status,
    };
  }
};

export const createJobTitle = async (
  title,
  organisationId = null,
  createdByUser = null
) => {
  try {
    let params = {
      title,
      createdByUser,
      organisation: organisationId,
    };

    const response = await uninterceptedAxiosInstance.post(
      backend_url + "jobs",
      { data: params },
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );
    let the_response = response;
    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err?.response?.status,
    };
  }
};
export const createBulkJobtitle = async (data = [], organisationId = null) => {
  try {
    let params = {
      data,
      organisation: organisationId,
    };

    const response = await uninterceptedAxiosInstance.post(
      backend_url + "jobs/import",
      params,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );
    let the_response = response;
    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err?.response?.status,
      error: err?.response?.data?.error?.message,
    };
  }
};

export const deleteJobTitle = async (ID, reason) => {
  try {
    let params = {
      data: [
        {
          id: ID,
          deleteReason: reason,
        },
      ],
    };
    const response = await uninterceptedAxiosInstance.post(
      backend_url + `jobs/removeJobs`,
      params,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );
    let the_response = response;
    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }
    return {
      status: err?.response?.status,
    };
  }
};
